import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webDiscount`

//  Apply Discount (Create Rule)
export const applyDiscountApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/apply`, formData)
}

// Delete / Remove Discount Rule
export const deleteDiscountApi = (id) => {
  return axiosInstance.delete(`${serverUrl}/${id}`)
}

//  Vendor → Get own discount list
export const getVendorDiscountsApi = () => {
  return axiosInstance.get(`${serverUrl}/vendor-discount`)
}

//  Admin → Get all discount rules
export const getAllDiscountsAdminApi = () => {
  return axiosInstance.get(`${serverUrl}/alldiscount`)
}
